import React, { type FC, useMemo } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import LayoutFooter from '@/registration/component/Register/Layout/Footer';
import { UiButton, UiHStack, UiIconCaretLeft, UiIconCaretRight, UiIconPlusCircle, UiStack } from '@/lib/ui';
import TicketList from './TicketList';
import { TicketType } from '@/api/constant';
import { useRegistrationQuery } from '@/registration/hook/useRegistrationQuery';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import { useRegisterSteps } from '@/registration/hook/useRegisterSteps';
import { useEventSettingsQuery } from '@/registration/hook/useEventSettingsQuery';
import InfoBox from '@/registration/component/InfoBox';
import EmptyWarningModal from './EmptyWarningModal';
import { useDisclosure } from '@chakra-ui/react';
import { useIsEmptyRegisTypeInCart } from '@/registration/hook/useIsEmptyRegisTypeInCart';
import BrandFooter from '@/registration/component/Register/Layout/BrandFooter';
import BaseThemeButton from '@/base/ThemeButton';

const MainTickets: FC = () => {
  const { eventId } = useRegisterRoute();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const registrationQuery = useRegistrationQuery(eventId);
  const { data: eventSetting } = useEventSettingsQuery(eventId);
  const { toNextStep, toPreviousStep, isReviewing } = useRegisterSteps();
  const { isEmptyMainTicketInCart } = useIsEmptyRegisTypeInCart(eventId);

  const handleNextStep = () => {
    if (isEmptyMainTicketInCart) {
      onOpen();
    } else {
      toNextStep();
    }
  };

  const registrationTypeLabel = useMemo(() => {
    return eventSetting?.pageMetadata?.mainTicket?.title || 'Registration type';
  }, [
    eventSetting?.pageMetadata?.mainTicket?.title,
  ]);

  return (
    <RegisterLayout>
      <QueryContainer query={registrationQuery}>
        {(registration) => {
          return (
            <>
              <BaseTransitionSlideLeft>
                <UiStack flexGrow={1} spacing={8}>
                  <InfoBox
                    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                    title={registrationTypeLabel}
                    description={eventSetting?.pageMetadata?.mainTicket?.description}
                  />
                  <TicketList key={registration?.attendeeCategoryId} ticketType={TicketType.Main} onEmpty={toNextStep} registration={registration} />
                </UiStack>
              </BaseTransitionSlideLeft>
              <UiStack height={96} />
              <LayoutFooter>
                <UiHStack justifyContent={'space-between'} flexGrow={1}>
                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={toPreviousStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  leftIcon={(*/}
                  {/*    <UiIconCaretLeft color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  {isReviewing ? 'Back' : 'Prev'}*/}
                  {/*</UiButton>*/}
                  <BaseThemeButton
                    theme={'gray'}
                    onClick={toPreviousStep}
                    leftIcon={(
                      <UiIconCaretLeft color={'text.primary'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    {isReviewing ? 'Back' : 'Prev'}
                  </BaseThemeButton>
                  <BrandFooter/>
                  {/*<UiButton*/}
                  {/*  size={'lg'}*/}
                  {/*  colorScheme={'primary'}*/}
                  {/*  onClick={handleNextStep}*/}
                  {/*  variant={'ghost'}*/}
                  {/*  fontSize={'lg'}*/}
                  {/*  rightIcon={(*/}
                  {/*    <UiIconCaretRight color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
                  {/*  )}*/}
                  {/*>*/}
                  {/*  {isReviewing ? 'Done' : 'Next'}*/}
                  {/*</UiButton>*/}
                  <BaseThemeButton
                    theme={'primary'}
                    onClick={handleNextStep}
                    rightIcon={(
                      <UiIconCaretRight color={'primary.800'} size={'lg'} weight={'bold'}/>
                    )}
                  >
                    {isReviewing ? 'Done' : 'Next'}
                  </BaseThemeButton>
                </UiHStack>
              </LayoutFooter>
            </>
          );
        }}
      </QueryContainer>
      <EmptyWarningModal
        isOpen={isOpen}
        onClose={onClose}
        message={`You need to add a ${registrationTypeLabel.toLowerCase()} to continue.`}
      />
    </RegisterLayout>
  );
};

export default MainTickets;
